import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle_on",
  "use": "icon-circle_on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M509.127 255.436c141.272 0 255.838 114.533 255.838 255.826S650.399 767.09 509.127 767.09c-141.299 0-255.837-114.534-255.837-255.827s114.54-255.826 255.837-255.826z\" fill=\"#196be6\" p-id=\"711\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol